import React from 'react';
import PropTypes from 'prop-types';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import KioskIcon from 'images/kiosk_icon.svg';
import TakeSurveyIcon from 'images/take_survey_icon.svg';
import style from './style.css';

const Boilerplate = window.cccisd.boilerplate;

const TakeAssessment = props => {
    const { session, reporterName, assessmentLink, closeModal, studentName } = props;

    const logoutAndRouteToSurvey = async (e, link) => {
        e && e.preventDefault();

        const resp = await axios.post(Boilerplate.route('app.logoutForKiosk'));
        if (resp?.data?.status === 'success') {
            window.location.href = link;
        } else {
            notification({ type: 'danger', message: 'Action cancelled. Failed to logout' });
        }
    };

    const renderButtonContent = () => {
        let content = {
            kiosk: (
                <div>
                    <h3>
                        Hand device to{' '}
                        {reporterName ? `${reporterName}` : `${studentName}'s ${session.settings.reporter}`}
                    </h3>
                    {reporterName && <h5>{`(${session.settings.reporter} of ${studentName})`}</h5>}
                    <p>
                        To protect your account, <strong>the system will log you out.</strong> When{' '}
                        {reporterName ?? `${studentName}'s ${session.settings.reporter}`} is finished, you will need to
                        log in again.
                    </p>
                </div>
            ),
            takeSurvey: (
                <div>
                    <h3>
                        Enter responses as{' '}
                        {reporterName ? `${reporterName}` : `${studentName}'s ${session.settings.reporter}`}
                    </h3>
                    {reporterName && <h5>{`(${session.settings.reporter} of ${studentName})`}</h5>}
                    <p>
                        <strong>The system will keep you logged in.</strong> To protect your account, do not hand the
                        device to {reporterName ?? `${studentName}'s ${session.settings.reporter}`} once you begin the
                        assessment(s).
                    </p>
                </div>
            ),
        };
        if (session.settings.reporter === 'Mental Health Provider') {
            content.kiosk = (
                <div>
                    <h3>Hand device to {`${studentName}'s provider (if not you)`}</h3>
                    <p>
                        To protect your account, <strong>the system will log you out.</strong> When{' '}
                        {reporterName ?? `the provider`} is finished, you will need to log in again.
                    </p>
                </div>
            );

            content.takeSurvey = (
                <div>
                    <h3>Enter responses as {`${studentName}'s provider (if not you)`}</h3>
                    <p>
                        <strong>The system will keep you logged in.</strong> To protect your account, do not hand the
                        device to {reporterName ?? `the provider`} once you begin the assessment(s).
                    </p>
                </div>
            );
        }

        if (session.settings.reporter === 'Student') {
            content.kiosk = (
                <div>
                    <h3>Hand device to {studentName}</h3>
                    <p>
                        To protect your account, <strong>the system will log you out.</strong> When {studentName} is
                        finished, you will need to log in again.
                    </p>
                </div>
            );
            content.takeSurvey = (
                <div>
                    <h3>Enter responses as {studentName}</h3>
                    <p>
                        <strong>The system will keep you logged in.</strong> To protect your account, do not hand the
                        device to {studentName} once you begin the assessment(s).
                    </p>
                </div>
            );
        }

        return content;
    };

    const renderDeploymentLinks = () => {
        if (!session.sessionDeploymentInfo) {
            // Should never happen
            return <h2>There are no available session at this time.</h2>;
        }

        return (
            <div className={style.takeAssessment}>
                <button
                    type="button"
                    className={style.assessmentButton}
                    style={{ marginRight: '0.5em' }}
                    onClick={e => logoutAndRouteToSurvey(e, assessmentLink)}
                >
                    <img src={KioskIcon} alt="Kiosk Icon" />
                    {renderButtonContent().kiosk}
                </button>
                <button
                    type="button"
                    className={style.assessmentButton}
                    onClick={e => {
                        window.location.href = assessmentLink;
                        closeModal();
                    }}
                >
                    <img src={TakeSurveyIcon} alt="Take Survey Icon" />
                    {renderButtonContent().takeSurvey}
                </button>
            </div>
        );
    };

    return <div>{renderDeploymentLinks()}</div>;
};

export default TakeAssessment;

TakeAssessment.propTypes = {
    session: PropTypes.object.isRequired,
    reporterName: PropTypes.string,
    studentName: PropTypes.string,
    assessmentLink: PropTypes.string.isRequired,
    closeModal: PropTypes.func.isRequired,
};

TakeAssessment.defaultProps = {};
